import { DialogContent, DialogContentProps, Theme, Palette, PaletteColor } from '@mui/material';
import { styled } from '@mui/styles';
interface Props {
  theme: Theme;
  backgroundColor?: keyof Palette;
}

export const PmiDialogContent = styled((props: DialogContentProps) => <DialogContent {...props} />)(
  ({ theme, backgroundColor }: Props) => ({
    backgroundColor: (theme.palette[backgroundColor || 'background'] as PaletteColor).main,
    padding: '30px 24px !important',
  })
);
